export function responseHandler(response){
   
    return response.text().then(text =>{
        let data;
        try { data = text ? JSON.parse(text) : null; }
        catch (error) { data = null; }
        if(!response.ok){
            const error = (data && (data.err || data.message)) || response.statusText || "Request failed";
            return Promise.reject(error);
        }

        return Promise.resolve(data);
    })
}
